import { createAction } from '../../../../../store.model';
import { OrderBy } from '../model/order-by.model';
import { ActionType } from '../transcript-summary.action';

export interface SortSummary {
    orderBy?: OrderBy;
}

export const sortSummary = createAction<ActionType, SortSummary>(
    ActionType.COACHING_DETAIL__TS__SORT_SUMMARY,
);
